import axios from 'axios';
import toast from 'react-hot-toast';

import { apiUrl } from '../apiUrl';
import { sortByOrder } from '../utility';

export const fetchConsents = async () => {
  try {
    const resp = await axios.get(`${apiUrl}/consents`);

    return sortByOrder(resp.data.consents);
  } catch (error) {
    console.log(error);
    toast.error('Wystąpił problem. Odśwież aplikację.');

    return [];
  }
};

const sendReservation = (input, type) => {
  let data = {
    full_name: input.fullName,
    parent_full_name: input.parent_full_name,
    email: input.email,
    date_of_birth: input.birthday,
    school_class: input.school_class,
    phone: input.mobile,
    known_client: input.known_client,
    comment: input.comment,
    consent_processing: input.tos,
    consent_policy: input.policy,
    consent_marketing: input.marketing,
    payment_type: input.payment_type,
    postal_code: input.postal_code,
    street_address: input.street_address,
    city: input.city,
    promo_coupon: input.promo_coupon,
  };

  let request;

  switch (type) {
    case 'workshop':
      data.workshop_occurrence_id = input.id;
      request = axios.post(`${apiUrl}/signup/workshop`, data).then(res => ({
        response: res,
        status: res.data?.status_enum ?? null,
      }));
      break;

    case 'summerplay':
      data.summerplay_workshop_id = input.id;
      data.days = input.days;
      data.client_full_name = 'RODZIC ' + input.fullName;
      data.child_full_name = input.fullName;

      request = axios.post(`${apiUrl}/newSummerplay/signup`, data).then(res => ({
        response: res,
        status: res.data?.status_enum ?? null,
      }));
      break;
    
    case 'one_time_workshop':
      data.summerplay_workshop_id = input.id;
      data.client_full_name = 'RODZIC ' + input.fullName;
      data.child_full_name = input.fullName;

      request = axios.post(`${apiUrl}/newSummerplay/one_time/signup`, data).then(res => ({
        response: res,
        status: res.data?.status_enum ?? null,
      }));
      break;

    default:
    case 'generic':
      data.type = input.genericType;
      data.generic_info = input.genericInfo;

      request = axios.post(`${apiUrl}/signup/generic`, data).then(res => ({
        response: res,
        status: res.data?.status_enum ?? null,
      }));
      break;
  }
  // console.log(data);
  // console.log("FORM NIE ZOSTAŁ WYSŁANY -- DEBUG");

   return request;
};

export const sendPost = async (data, type) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { status } = await sendReservation(data, type);

    return {success: true, status: status};
  } catch (error) {
    console.log(error);
    toast.error('Coś poszło nie tak.');

    return {success: false};
  }
};
